<template>
  <div>
    <!-- tagline -->
    <v-row align="center" v-if="!hideLabel">
      <v-icon class="material-icons">article</v-icon>
      <div >{{ $t("story.tagline") }}</div>
    </v-row>
    <v-row align="center">
      <v-textarea
        v-model="summary"
        id="taglineTextArea"
        :label="$t('story.basicInfoForm.addYourTagline')"
        single-line
        rows="5"
        auto-grow
        :counter="TAGLINE_TEXT_MAX_LENGTH"
        :rules="[
          () =>
            ( summary.length <= TAGLINE_TEXT_MAX_LENGTH) ||
            $t('forms.maxLimitCharacters', {
              limit: TAGLINE_TEXT_MAX_LENGTH,
            }),
        ]"
        outlined
        solo
        :disabled="disabled"
      />
    </v-row>
  </div>
</template>
<script>
const TAGLINE_TEXT_MAX_LENGTH = 160
export default {
  props: {
    value: String,
    disabled: Boolean,
    hideLabel: { type: Boolean, default: false },
  },
  data() {
    return {
      summary: this.value,
    };
  },
  watch: {
    summary(newValue) {
      this.$emit("input", newValue);
    },
    value(newValue) {
      if (this.summary != newValue) {
        this.summary = newValue;
      }
    },
  },
  computed: {
    TAGLINE_TEXT_MAX_LENGTH() {
      return TAGLINE_TEXT_MAX_LENGTH
    }
  }
}
</script>